export const PRESENT = 1
export const ABSENT = 2
